import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
};

export const Root = styled.div`
  margin-top:6px;
  position: relative;
  padding: 0px 0px;
`;

export const TabsContainer = styled.div`
  width: 562px;
  min-height: 200px;
  padding: 30px 0px 0px 0px;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
  z-index: 101;
  margin-top: 6px;
  margin-left: -377px;
  flex-direction:column; 
`;


export const ContentContainer = styled.div`
  position: relative;
`;